import React from 'react';

import './RothConversionSummary.scss';
import If from '../../../Shared/If/If';
import FromFundsSummary from './FromFundsSummary';
import TaxSummary from './TaxSummary';
import BeneficiarySummary from './BeneficiarySummary';
import TermsSummary from './TermsSummary';

const RothConversionSummary = ({ onEdit, step, className }) => {
  // summary based on steps
  return (
    <div>
      <If test={step === 1}>
        <FromFundsSummary step={step} className={className} onEdit={onEdit} />
      </If>
      <If test={step === 2}>
        <TaxSummary step={step} className={className} onEdit={onEdit} />
      </If>
      <If test={step === 3}>
        <BeneficiarySummary step={step} className={className} onEdit={onEdit} />
      </If>
      <If test={step === 4}>
        <TermsSummary step={step} className={className} onEdit={onEdit} />
      </If>
    </div>
  );
};
export default RothConversionSummary;
